"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconInput = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M6.07 26.48h34.82v-3.3h-37a1.15 1.15 0 0 0-1.15 1.15v21.33a1.15 1.15 0 0 0 1.15 1.15h37v-3.3H6.07zM66.07 23.18h-13.6v3.3h11.46v17H52.47v3.3h13.6a1.15 1.15 0 0 0 1.15-1.15V24.34a1.15 1.15 0 0 0-1.15-1.16z"
  }), _react["default"].createElement("path", {
    d: "M52.86 50.28H49a.65.65 0 0 1-.65-.65V20.36a.65.65 0 0 1 .65-.65h3.89A1.15 1.15 0 0 0 54 18.56v-1a1.15 1.15 0 0 0-1.15-1.15H49a3.92 3.92 0 0 0-2 .57l-.26.16-.32-.14a3.92 3.92 0 0 0-2-.57H40.5a1.15 1.15 0 0 0-1.15 1.15v1a1.15 1.15 0 0 0 1.15 1.15h3.89a.65.65 0 0 1 .65.65v29.26a.65.65 0 0 1-.65.65H40.5a1.15 1.15 0 0 0-1.15 1.15v1a1.15 1.15 0 0 0 1.15 1.15h3.89a3.91 3.91 0 0 0 2-.57l.26-.16.26.16a3.92 3.92 0 0 0 2 .57h3.89a1.15 1.15 0 0 0 1.2-1.16v-1a1.15 1.15 0 0 0-1.14-1.15z"
  })),
  height: undefined,
  width: undefined
});
IconInput.displayName = 'IconInput';
var _default = IconInput;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/input.js
// module id = 576
// module chunks = 0